import $ from 'jquery'

// Ensure Rails UJS remote works; fallback to jQuery AJAX
document.addEventListener('DOMContentLoaded', () => {
  function toJsUrl(url) {
    try {
      const u = new URL(url, window.location.origin)
      u.searchParams.set('format', 'js')
      return u.toString()
    } catch(e) {
      // Fallback for relative URLs without origin
      if (url.includes('?')) {
        return url + '&format=js'
      } else {
        return url + '?format=js'
      }
    }
  }

  // Filters form submit via AJAX
  $(document).on('submit', '#concepts-filters', function(e) {
    e.preventDefault()
    const $form = $(this)
    const url = toJsUrl($form.attr('action'))
    const data = $form.serialize()
    console.debug('[filters] submitting via AJAX →', url, data)
    return $.ajax({
      url: url,
      method: 'GET',
      data: data,
      dataType: 'script',
      headers: { 'Accept': 'text/javascript, application/javascript, */*; q=0.01' }
    }).always(() => {
      try { $form.find('input[type="submit"][disabled], button[type="submit"][disabled]').prop('disabled', false) } catch(e) {}
    })
  })

  // Pagination via AJAX within results container
  $(document).on('click', '#concepts-results .pagination a', function(e) {
    e.preventDefault()
    const url = toJsUrl($(this).attr('href'))
    const $form = $('#concepts-filters')
    const data = $form.length ? $form.serialize() : {}
    console.debug('[pagination] loading via AJAX →', url, data)
    return $.ajax({
      url: url,
      method: 'GET',
      data: data,
      dataType: 'script',
      headers: { 'Accept': 'text/javascript, application/javascript, */*; q=0.01' }
    })
  })
})


